module.exports = __webpack_public_path__ + "statics/img/7.902c3e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/7.jpg
// module id = fVkq
// module chunks = 1